/** Words for the assurance register: providers, tiers and the rating as a status mark. */

import { ASSURANCE_PROVIDER_NAMES, ASSURANCE_TIER_WORDS, ASSURANCE_WORDS, assuranceRowName, type AssuranceRating } from '@aioe/shared';

import { StatusMark } from './ui.tsx';

export const providerWord = (id: string): string => ASSURANCE_PROVIDER_NAMES[id] ?? id;
export const tierWord = (id: string): string => ASSURANCE_TIER_WORDS[id] ?? id;
/** A row's own name when it has one (an organisation's provider, a row Mojo Up added), else the provider's. */
export const rowWord = (r: { provider: string; name?: string }): string => assuranceRowName(r);

const MARKS: Record<AssuranceRating, 'online' | 'connected' | 'idle' | 'disabled'> = { S: 'online', E: 'connected', P: 'idle', X: 'disabled' };

/** The rating as a dot and its word, so colour is never the only signal. */
export function RatingMark({ rating }: { rating: AssuranceRating }) {
  return <StatusMark state={MARKS[rating]} label={ASSURANCE_WORDS[rating]} />;
}
